var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    alertWrapperMargin: spacing.xSmall,
    scoreMargin: spacing.small,
    scoreZIndex: '2222',
    scorePercentageFontSize: typography.fontSizeLarge,
    scorePercentageFontWeight: typography.fontWeightBold,
    infoWrapperMargin: spacing.small,
    inforWrapperPadding: spacing.small
  };
};
export default generateComponentTheme;